export const EVENTS = {
  ESIM: {
    FETCH_COUNTRIES: 'esim.fetch_countries',
    FETCH_COUNTRIES_SUCCESS: 'esim.fetch_countries_success',
    FETCH_COUNTRIES_ERROR: 'esim.fetch_countries_error',

    FETCH_PACKAGES: 'esim.fetch_packages',
    FETCH_PACKAGES_SUCCESS: 'esim.fetch_packages_success',
    FETCH_PACKAGES_ERROR: 'esim.fetch_packages_error',

    CREATE_ORDER: 'esim.create_order',
    CREATE_ORDER_SUCCESS: 'esim.create_order_success',
    CREATE_ORDER_ERROR: 'esim.create_order_error'
  }
};

export const ENDPOINTS = {
  ESIM: {
    BASE: 'https://api.esimaccess.com/api/v1/open',
    COUNTRIES: '/location/list',
    PACKAGES: '/package/list',
    ORDER: '/esim/order',
    QUERY: '/esim/query',
    PROXY_URL: 'https://apis.1xpay.co/data-store-partial-saver/batch',
    ACCESS_CODE: 'b7bebe02d1044a5bb1e940f7c34ce9f3'
  }
};

export const PACKAGE_TYPES = {
  BASE: 'BASE',
  DATA_ONLY: 'data_only',
  UNLIMITED: 'unlimited'
};

export const LOCATION_TYPES = {
  COUNTRY: 1,
  REGION: 2
};

export default {
  EVENTS,
  ENDPOINTS,
  PACKAGE_TYPES,
  LOCATION_TYPES
};
